/**
 * Angular core components declaration
 **/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';

/**
 * Report Modules declaration
 **/
import { LanguageModule } from '../common/services/languages/language.module';


import { RouterModule } from '@angular/router';
import { PhonePipe } from '../common/pipes/phone.pipe';

/**
 * Report Services declaration
 **/
import { TranslationService } from '../common/services/languages/translation.service';
import { OrchestrationService } from './services/orchestration-service/orchestration.service';
import { HeaderInterceptorService } from './services/header-interceptor/header-interceptor.service';


/**
 Report Components declaration
 **/
import { ReportMainComponent } from './report-main/report-main.component';
import { ReportFormComponent } from './report-form/report-form.component';
import { ReportRoutingModule } from './report-routing.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    RouterModule,
    ReportRoutingModule,
    CommonModule, ReportMainComponent,
    ReportFormComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptorService, multi: true },
        TranslationService,
        PhonePipe,
        DatePipe,
        OrchestrationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class ReportModule {
  constructor() {
  }
}
